/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// const MIN_ALLOWED_FONT_SIZE = 8;
// const MAX_ALLOWED_FONT_SIZE = 72;

// export const parseAllowedFontSize = (input) => {
//   const match = input.match(/^(\d+(?:\.\d+)?)px$/);
//   if (match) {
//     const n = Number(match[1]);
//     if (n >= MIN_ALLOWED_FONT_SIZE && n <= MAX_ALLOWED_FONT_SIZE) {
//       return input;
//     }
//   }
//   return "";
// };

export function parseAllowedColor(input) {
  return /^rgb\(\d+, \d+, \d+\)$/.test(input) ? input : "";
}

export function parseTextAlign(input) {
  const validTextAligns = ["left", "right", "center", "justify"];
  return validTextAligns.includes(input) ? input : "";
}
